module.exports = __webpack_public_path__ + "img/dance-masters-seal.6126ff5c.webp";